module.exports = __webpack_public_path__ + "img/logo.dd3d8a45.svg";